export default __webpack_public_path__ + "static/media/Sepember2012.88cf8c4f.png";